import { render, staticRenderFns } from "./FinishForm.vue?vue&type=template&id=24c481b2&"
import script from "./FinishForm.vue?vue&type=script&lang=js&"
export * from "./FinishForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports